// src/utils/notificationRoutes.js
export function resolveNotificationRoute(notification) {
  const data = notification?.data || {};
  const type = (notification?.type || data?.type || '').toLowerCase();

  // ✅ Highest priority: explicit page from server push payload
  if (typeof data.page === 'string' && data.page.startsWith('/')) {
    return data.page;
  }

  // Optional: support url too (some flows use url)
  if (typeof data.url === 'string') {
    try {
      const u = new URL(data.url, window.location.origin);
      return u.pathname + u.search + u.hash;
    } catch {}
  }

  // ── Type-based routing ──────────────────────────────────────────────────

  // Messaging → inbox
  if (['message', 'new_message', 'chat_message', 'new_chat_message'].includes(type)) {
    if (data.chatId) return `/messages/${data.chatId}`;
    return '/messages';
  }

  // NOTE: Scrimmage-related notification types (scrimmage_*, match_*, interest_*,
  // score_review, opportunity_alert, local_scrimmage, standard_alert) were
  // removed when the scrimmage feature was deprecated. Legacy notifications of
  // those types will fall through to `null` below and display as
  // non-actionable entries rather than routing to dead pages.

  return null;
}
